






































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";

@Component({
  components: {
    Add
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "tel/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "电话号码", dataIndex: "tel" },
    { title: "语音内容", scopedSlots: { customRender: "text" } },
    { title: "时间", dataIndex: "created_time" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  mounted() {
    this.loadData();
  }
}
